import { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '../Button';
import { useInviteMember } from '../../lib/mutations/team';
import type { TeamMember } from '../../lib/queries/team';

const inputCls =
  'w-full rounded border border-white/10 bg-bg-elevated px-3 py-2 text-sm text-primary placeholder:text-muted focus:border-[--color-accent] focus:outline-none';

export function InviteMemberForm({
  onCloseModal,
}: {
  onCloseModal?: () => void;
}) {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState<TeamMember['role']>('support');
  const invite = useInviteMember();

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    invite.mutate({ email, role }, { onSuccess: onCloseModal });
  }

  return (
    <div>
      <div className="flex items-center justify-between border-b border-white/8 px-6 py-4">
        <h2 className="text-primary text-base font-medium">
          Invite team member
        </h2>
        <button
          type="button"
          onClick={onCloseModal}
          className="text-muted hover:text-primary transition-colors"
        >
          <X size={18} />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4 py-5">
        <div className="space-y-4 px-6 py-4">
          <div>
            <label className="text-muted mb-1 block text-xs font-medium">
              Email address
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="name@example.com"
              className={inputCls}
            />
          </div>

          <div>
            <label className="text-muted mb-1 block text-xs font-medium">
              Role
            </label>
            <select
              value={role}
              onChange={(e) => setRole(e.target.value as TeamMember['role'])}
              className={inputCls}
            >
              <option value="support">Support</option>
              <option value="read_only">Read-only</option>
              <option value="admin">Admin</option>
            </select>
          </div>

          {invite.isError && (
            <p className="text-danger text-sm">
              {(invite.error as Error).message}
            </p>
          )}
        </div>

        <div className="border-primary/8 flex justify-end gap-3 border-t px-6 pt-4">
          <Button type="button" variant="secondary" onClick={onCloseModal}>
            Cancel
          </Button>
          <Button type="submit" disabled={invite.isPending || !email}>
            {invite.isPending ? 'Inviting…' : 'Send invite'}
          </Button>
        </div>
      </form>
    </div>
  );
}
